import React, { Fragment } from 'react';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import {
  COMUNICACAO_PLANO,
  CUSTEIO_ADMINISTRATIVO,
  EXTRATO_PARTICIPANTE,
  OPCAO_INSTITUTO,
  SEGUNDA_VIA_BOLETO,
} from '../../../utils/paths';

const links = [
  {
    label: 'Extrato do Participante',
    to: EXTRATO_PARTICIPANTE,
    id: 'extrato_cnpc',
  },
  {
    label: 'Comunicação sobre o plano',
    to: COMUNICACAO_PLANO,
    id: 'comunicacao_plano',
  },
  {
    label: 'Demonstrativo Custeio Administrativo',
    to: CUSTEIO_ADMINISTRATIVO,
  },
  {
    label: 'Obter Opção por Instituto',
    to: OPCAO_INSTITUTO,
    id: 'extrato_opcao',
  },
  {
    label: 'Segunda via de boleto',
    to: SEGUNDA_VIA_BOLETO,
    id: 'segunda_via_boleto',
  },
];

export const OutrosCard = () => {
  const telasAtivas = useSelector(
    (state) => state.configs.telasDisponiveis.data
  );

  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-32">Outros</h1>

        {links.map((link) => {
          if (link.id) {
            if (telasAtivas[link.id]) {
              return (
                <Fragment key={link.to}>
                  <hr className="my-4" />
                  <FLink to={link.to} icon>
                    {link.label}
                  </FLink>
                </Fragment>
              );
            }

            return null;
          }

          return (
            <Fragment key={link.to}>
              <hr className="my-4" />
              <FLink to={link.to} icon>
                {link.label}
              </FLink>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
};
